import { GET_RAZORPAY_KEY_ID, optionsThemeColor } from "../../constants/config";
import { getRazorpayCallbackUrl } from "../../constants/regionConfig";

async function RazorpayPaymentHandler(punchPaymentResponse, order, regionId) {
  const paymentOptions = {
    key: GET_RAZORPAY_KEY_ID(order.vertical_id),
    amount: punchPaymentResponse.amount * 100,
    order_id: punchPaymentResponse.payment_mode_details.gateway_order_id,
    callback_url: getRazorpayCallbackUrl(regionId),
    theme: optionsThemeColor,
    redirect: true,
  };

  const pay = new window.Razorpay(paymentOptions);
  pay.open();
}

export { RazorpayPaymentHandler };
